import { Box } from "@mui/material";
import { memo } from "react";
import { useModals } from "../../../../context/ModalContext";
import { JobCard } from "./JobCard";
import { Job } from "../../interfaces/job.interfaces";
import { JobDetailsModalContent } from "./JobDetModal";

interface Props {
  job: Job;
  jobsAllQuery: any;
  autoOpen?: boolean;
  onAutoOpenDone?: () => void;
  onJobModalOpened?: (modalKey: string) => void;
}

export const JobCardLayout = memo(({ job, jobsAllQuery, onJobModalOpened }: Props) => {
  console.count("render JobCardLayout");
  console.count(`render JobCardLayout ${job?.id}`);
  const { openModal } = useModals();

  const modalKey = `JobCard-${job?.id}`;

  const handleJobUpdated = () => {
    jobsAllQuery?.refetch?.();
  };

  const handleOpenJobModal = (event?: any) => {
    event?.stopPropagation?.();
    onJobModalOpened?.(modalKey);
    openModal(modalKey, <JobDetailsModalContent job={job} modalKey={modalKey} onJobUpdated={handleJobUpdated} />);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", mb: 2, alignItems: "center" }}>
      <Box sx={{ width: "100%", cursor: "pointer" }} onClick={handleOpenJobModal}>
        <JobCard job={job} onJobUpdated={handleJobUpdated} />
      </Box>
    </Box>
  );
});
